import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const VISIONS = [
  {
    id: 'ecology', label: '守护生态', icon: 'ri-leaf-line', color: '#00ff88',
    title: '元宇宙守护地球生态',
    desc: '通过将人类活动迁移到元宇宙，大幅减少对物理世界的资源消耗。数字孪生技术让我们在不破坏自然的前提下，实现经济的持续增长。',
    image: 'https://public.readdy.ai/ai/img_res/cb0c6a57b0be647e9c7543ca969fa8f9.jpg',
    stats: [{ label: '碳排放减少', value: '70%' }, { label: '森林覆盖率', value: '+35%' }, { label: '物种灭绝率', value: '-90%' }, { label: '海洋污染', value: '-80%' }],
    story: '2038年，全球90%的会议在元宇宙中举行，航空业碳排放减少了60%。数字孪生农业让粮食产量提升300%，同时耕地面积减少了50%，让大片土地回归自然。',
    actions: ['数字孪生农业', '虚拟旅游替代', '元宇宙办公', '数字化制造'],
  },
  {
    id: 'peace', label: '维护和平', icon: 'ri-heart-line', color: '#00d4ff',
    title: '元宇宙构建世界和平',
    desc: '当人们在元宇宙中共同生活、工作和创造，文化隔阂逐渐消融。量子加密通信让外交谈判更透明，AI调解系统让冲突在升级前得到化解。',
    image: 'https://readdy.ai/api/search-image?query=world%20peace%20metaverse%20people%20from%20different%20cultures%20meeting%20holographic%20globe%20unity%20diversity%20futuristic&width=900&height=500&seq=mv2&orientation=landscape',
    stats: [{ label: '武装冲突减少', value: '65%' }, { label: '外交谈判成功率', value: '94%' }, { label: '难民数量减少', value: '80%' }, { label: '全球满意度', value: '8.7/10' }],
    story: '2040年，联合国在元宇宙中建立了"和平广场"，来自195个国家的代表每天在这里交流。AI调解系统在过去5年内成功化解了47起潜在武装冲突。',
    actions: ['元宇宙外交', 'AI冲突调解', '文化交流平台', '数字难民援助'],
  },
  {
    id: 'equality', label: '消除歧视', icon: 'ri-group-line', color: '#ff00ff',
    title: '元宇宙实现真正平等',
    desc: '在元宇宙中，你可以选择任何外貌、性别和身份。当人们习惯了以思想和能力而非外表来评判他人，现实世界的歧视也随之减少。',
    image: 'https://readdy.ai/api/search-image?query=diversity%20equality%20metaverse%20avatars%20different%20people%20united%20digital%20world%20inclusive%20technology%20futuristic&width=900&height=500&seq=mv3&orientation=landscape',
    stats: [{ label: '就业歧视减少', value: '75%' }, { label: '性别薪酬差距', value: '-90%' }, { label: '残障人士就业率', value: '+200%' }, { label: '跨文化婚姻', value: '+150%' }],
    story: '2036年，元宇宙中的"盲选招聘"系统让雇主只能看到候选人的能力数据，不知道其外貌、年龄和性别。这一系统推广后，就业歧视投诉减少了75%。',
    actions: ['匿名身份系统', '能力优先评估', '无障碍元宇宙', '文化融合项目'],
  },
  {
    id: 'environment', label: '减少污染', icon: 'ri-recycle-line', color: '#ffaa00',
    title: '循环经济与零污染未来',
    desc: '数字化生产和循环经济模式彻底改变了人类的消费方式。3D打印按需生产消除了库存浪费，区块链追踪确保每一件产品都能被完全回收利用。',
    image: 'https://readdy.ai/api/search-image?query=circular%20economy%20zero%20pollution%20clean%20energy%20recycling%20futuristic%20technology%20green%20city%20sustainable&width=900&height=500&seq=mv4&orientation=landscape',
    stats: [{ label: '工业废物减少', value: '85%' }, { label: '可再生能源占比', value: '95%' }, { label: '塑料污染减少', value: '92%' }, { label: '空气质量提升', value: '300%' }],
    story: '2041年，全球首个"零废物城市"在大湾区建成。所有产品都有数字护照，记录其完整生命周期。当产品报废时，AI自动将其分解为原材料，重新进入生产循环。',
    actions: ['数字产品护照', '按需3D打印', '区块链溯源', '能源互联网'],
  },
  {
    id: 'culture', label: '文化融合', icon: 'ri-global-line', color: '#8800ff',
    title: '元宇宙文化大融合',
    desc: '元宇宙打破了语言和地理的壁垒，让全球200多种文化在同一个数字空间中相遇、碰撞和融合，创造出前所未有的文化多样性。',
    image: 'https://readdy.ai/api/search-image?query=cultural%20fusion%20metaverse%20world%20cultures%20meeting%20digital%20space%20art%20music%20dance%20diversity%20celebration%20futuristic&width=900&height=500&seq=mv5&orientation=landscape',
    stats: [{ label: '跨文化合作项目', value: '500万+' }, { label: '濒危语言保护', value: '2000种' }, { label: '文化遗产数字化', value: '100%' }, { label: '全球艺术家', value: '10亿+' }],
    story: '2039年，元宇宙文化节吸引了来自全球的50亿人参与。一位中国传统戏曲艺术家与非洲鼓乐手和巴西桑巴舞者共同创作了一部元宇宙歌剧，成为人类文化史上的里程碑。',
    actions: ['实时翻译系统', '文化遗产VR', '跨文化创作平台', '语言保护计划'],
  },
];

const IMPACT_DATA = [
  { year: '2025', event: 'META66元宇宙愿景白皮书发布', color: '#00d4ff' },
  { year: '2027', event: '全球首个元宇宙生态保护区建立', color: '#00ff88' },
  { year: '2030', event: '联合国元宇宙和平协议签署', color: '#ff00ff' },
  { year: '2033', event: '元宇宙文化融合指数首次超越现实世界', color: '#ffaa00' },
  { year: '2036', event: '全球碳排放因元宇宙迁移减少50%', color: '#8800ff' },
  { year: '2040', event: '元宇宙实现真正的全球平等社会', color: '#ff6600' },
];

export default function MetaVisionPage() {
  const navigate = useNavigate();
  const [activeVision, setActiveVision] = useState(VISIONS[0]);
  const [activeAction, setActiveAction] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'META66元宇宙愿景 | 守护生态·维护和平·消除歧视·减少污染·文化融合';

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://meta66.cn';

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${siteUrl}/meta-vision#webpage`,
        url: `${siteUrl}/meta-vision`,
        name: 'META66元宇宙愿景 | 守护生态·维护和平·消除歧视·减少污染·文化融合',
        description: '探索META66五大人类愿景：元宇宙守护地球生态、构建世界和平、实现真正平等、循环经济零污染、文化大融合，以前沿科技推动人类文明可持续发展。',
        inLanguage: 'zh-CN',
        dateModified: '2026-04-04',
        isPartOf: { '@id': `${siteUrl}/#website` },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: '元宇宙愿景', item: `${siteUrl}/meta-vision` },
          ],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: '元宇宙五大人类愿景：科技推动文明进化',
        url: `${siteUrl}/meta-vision`,
        description: 'META66通过元宇宙技术推动守护生态、维护和平、消除歧视、减少污染与文化融合五大人类愿景，以前沿科技实现可持续发展。',
        author: { '@type': 'Organization', name: 'META66' },
        publisher: { '@type': 'Organization', name: 'META66', url: siteUrl },
        dateModified: '2026-04-04',
        inLanguage: 'zh-CN',
        keywords: '元宇宙,生态保护,世界和平,消除歧视,循环经济,文化融合',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '元宇宙如何帮助减少碳排放？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '通过将人类活动迁移到元宇宙，大幅减少对物理世界的资源消耗。数字孪生农业让粮食产量提升300%，同时耕地面积减少50%。预计到2036年，全球碳排放因元宇宙迁移减少70%。',
            },
          },
          {
            '@type': 'Question',
            name: '元宇宙如何促进文化融合？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '元宇宙打破语言和地理壁垒，让全球200多种文化在同一数字空间中相遇、碰撞和融合。已保护2000种濒危语言，支持500万+跨文化合作项目，全球艺术家超10亿。',
            },
          },
        ],
      },
    ];

    const existingScript = document.getElementById('schema-metavision-jsonld');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'schema-metavision-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-metavision-jsonld');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', 'PingFang SC', sans-serif" }}>
      {/* Header */}
      <div className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line" />
            <span className="text-sm">返回首页</span>
          </button>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #00ff88, #00d4ff)' }}>
              <i className="ri-earth-line text-white text-sm" />
            </div>
            <span className="font-bold text-gray-900">元宇宙愿景</span>
          </div>
          <div className="text-sm text-gray-400">META66 · 人类未来</div>
        </div>
      </div>

      {/* Hero */}
      <div className="relative h-96 overflow-hidden">
        <img src={activeVision.image} alt="元宇宙愿景" className="w-full h-full object-cover object-top transition-all duration-700" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" />
        <div className="absolute inset-0 flex items-center px-16">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/20 bg-white/10 backdrop-blur-sm mb-4">
              <i className={`${activeVision.icon} text-sm`} style={{ color: activeVision.color }} />
              <span className="text-sm font-medium" style={{ color: activeVision.color }}>{activeVision.label}</span>
            </div>
            <h1 className="text-5xl font-black text-white mb-3" style={{ fontFamily: "'Orbitron', monospace" }}>META VISION</h1>
            <p className="text-gray-300 text-lg max-w-xl">{activeVision.desc}</p>
          </div>
        </div>
      </div>

      {/* Vision Tabs */}
      <div className="border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-1 overflow-x-auto py-2">
            {VISIONS.map(v => (
              <button key={v.id} onClick={() => setActiveVision(v)}
                className="flex items-center gap-2 px-5 py-3 rounded-xl text-sm font-medium transition-all whitespace-nowrap cursor-pointer flex-shrink-0"
                style={{
                  background: activeVision.id === v.id ? `${v.color}15` : 'transparent',
                  color: activeVision.id === v.id ? v.color : '#888',
                  border: `1px solid ${activeVision.id === v.id ? v.color : 'transparent'}`,
                }}>
                <i className={v.icon} />
                {v.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Vision Detail */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-black text-gray-900 mb-4">{activeVision.title}</h2>
            <p className="text-gray-600 leading-relaxed mb-6">{activeVision.desc}</p>

            {/* Story */}
            <div className="p-6 rounded-2xl mb-6" style={{ background: `${activeVision.color}08`, border: `1px solid ${activeVision.color}20` }}>
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-book-open-line" style={{ color: activeVision.color }} />
                <span className="font-bold text-gray-900">未来故事</span>
              </div>
              <p className="text-gray-700 leading-relaxed italic">{activeVision.story}</p>
            </div>

            {/* Actions */}
            <div>
              <h3 className="font-bold text-gray-900 mb-4">核心行动方案</h3>
              <div className="grid grid-cols-2 gap-3">
                {activeVision.actions.map(action => (
                  <button key={action} onClick={() => setActiveAction(activeAction === action ? null : action)}
                    className="p-4 rounded-xl text-left transition-all cursor-pointer"
                    style={{
                      background: activeAction === action ? `${activeVision.color}15` : '#f9f9f9',
                      border: `1px solid ${activeAction === action ? activeVision.color : '#eee'}`,
                    }}>
                    <div className="flex items-center gap-2">
                      <span className="w-2 h-2 rounded-full" style={{ background: activeVision.color }} />
                      <span className="font-medium text-gray-900 text-sm">{action}</span>
                    </div>
                    {activeAction === action && (
                      <p className="text-gray-500 text-xs mt-2 leading-relaxed">
                        通过{action}技术，我们正在构建一个更可持续、更公平的未来世界，让每一个人都能从中受益。
                      </p>
                    )}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Stats */}
          <div>
            <div className="p-6 rounded-2xl mb-4" style={{ background: `${activeVision.color}08`, border: `1px solid ${activeVision.color}20` }}>
              <h3 className="font-bold text-gray-900 mb-4">影响力数据</h3>
              {activeVision.stats.map(stat => (
                <div key={stat.label} className="mb-4">
                  <div className="flex justify-between items-center mb-1">
                    <span className="text-gray-500 text-sm">{stat.label}</span>
                    <span className="font-black text-xl" style={{ color: activeVision.color }}>{stat.value}</span>
                  </div>
                  <div className="h-1.5 rounded-full bg-gray-100">
                    <div className="h-full rounded-full" style={{ width: '75%', background: activeVision.color }} />
                  </div>
                </div>
              ))}
            </div>

            <div className="p-5 rounded-2xl border border-gray-100">
              <h3 className="font-bold text-gray-900 mb-3">META66的承诺</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                META66致力于通过前沿科技推动人类社会的可持续发展。我们相信，元宇宙不仅是技术的革命，更是人类文明的进化。
              </p>
              <button onClick={() => navigate('/')} className="mt-4 w-full py-3 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer"
                style={{ background: activeVision.color, color: '#000' }}>
                探索META66核心技术 →
              </button>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="mb-16">
          <h2 className="text-3xl font-black text-gray-900 mb-8 text-center">愿景实现时间线</h2>
          <div className="relative">
            <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-gray-200 -translate-x-1/2" />
            {IMPACT_DATA.map((item, i) => (
              <div key={item.year} className={`flex items-center gap-8 mb-8 ${i % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                <div className={`flex-1 ${i % 2 === 0 ? 'text-right' : 'text-left'}`}>
                  <div className="inline-block p-4 rounded-2xl bg-gray-50 border border-gray-100">
                    <div className="font-black text-2xl mb-1" style={{ color: item.color }}>{item.year}</div>
                    <p className="text-gray-700 text-sm">{item.event}</p>
                  </div>
                </div>
                <div className="w-4 h-4 rounded-full border-4 border-white z-10 flex-shrink-0" style={{ background: item.color }} />
                <div className="flex-1" />
              </div>
            ))}
          </div>
        </div>

        {/* All Visions Grid */}
        <div>
          <h2 className="text-3xl font-black text-gray-900 mb-8 text-center">五大人类愿景</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {VISIONS.map(v => (
              <button key={v.id} onClick={() => setActiveVision(v)}
                className="p-5 rounded-2xl text-center transition-all cursor-pointer hover:-translate-y-1"
                style={{
                  background: activeVision.id === v.id ? `${v.color}15` : '#f9f9f9',
                  border: `1px solid ${activeVision.id === v.id ? v.color : '#eee'}`,
                }}>
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-3" style={{ background: `${v.color}20` }}>
                  <i className={`${v.icon} text-xl`} style={{ color: v.color }} />
                </div>
                <div className="font-bold text-gray-900 text-sm mb-1">{v.label}</div>
                <div className="text-gray-400 text-xs">{v.stats[0].value}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
